<template>
    <v-dialog
        v-model="displayDialog"
        width="500"
        :persistent="true"
    >
        <v-card dark>
            <v-card-title
                class="headline"
                primary-title
            >
                <h2 class="dialog-confirm-title">{{ titleAsData || title }}</h2>
            </v-card-title>
                <div class="dialog-text">{{$t('partials.dialog_confirm_delete_app.text', {verboseContent: verboseTarget})}}</div>
                <div
                    v-if="targetModel === 'application'"
                    class="dialog-text"
                    v-html="$t('partials.dialog_confirm_delete_app.text_list_application')">
                </div>
                <div
                    v-if="targetModel === 'instance'"
                    class="dialog-text"
                    v-html="$t('partials.dialog_confirm_delete_app.text_list_instance')">
                </div>
                <div class="dialog-text">{{$t('partials.dialog_confirm_delete_app.text_action_waring')}}</div>
            <v-card-text>
            </v-card-text>
            <v-form ref="form">
                <div class="dialog-text">{{$t('partials.dialog_confirm_delete_app.text_field_label')}}</div>
                <v-text-field
                    class="dialog-confirm-field"
                    ref="application-delete-form"
                    v-model="confirmTextField"
                    :rules="formActive?confirmRules:[]"
                    required
                ></v-text-field>
            </v-form>
            <v-divider></v-divider>
            </el-form>
            <v-card-actions>
                <v-layout class="dialog-confirm-delete-buttons">
                    <v-flex>
                        <v-btn
                            @click="cancel"
                        >
                            {{ textDecline }}
                        </v-btn>
                    </v-flex>
                    <v-flex>
                        <v-btn
                            color="error"
                            @click="confirm"
                        >
                            {{ textConfirm }}
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import rulesMixins from '@/components/Mixins/rulesMixins.vue';
export default {
    mixins: [rulesMixins],
    components: {},
    props: {
        title: {
            type: String,
            required: false,
            default: '',
        },
        textConfirm: {
            type: String,
            required: false,
            default: function() {
                return this.$t('partials.dialog_confirm_delete_app.default_confirm');
            },
        },
        textDecline: {
            type: String,
            required: false,
            default: function() {
                return this.$t('partials.dialog_confirm_delete_app.default_cancel');
            },
        },
        callbackConfirm: {
            type: Function,
            required: false,
            default (){
                return ()=>{return Promise.resolve()};
            }
        },
        callbackDecline: {
            type: Function,
            required: false,
            default (){
                return ()=>{return Promise.resolve()};
            }
        },
        validateFieldLabel: {
            type: String,
            required: false,
            default: '',
        },
        verboseTarget: {
            type: String,
            required: true
        },
        targetModel: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            displayDialog: false,
            resolve: null,
            titleAsData: null,
            textAsData: null,
            confirmTextField: '',
        };
    },
    computed: {
        confirmRules() {
            if(this.formActive){
                return [
                    v => !!v || this.$t('partials.dialog_confirm_delete_app.rules_empty_field'),
                    v => v === this.$t('partials.dialog_confirm_delete_app.confirm_field_text') ? v === this.$t('partials.dialog_confirm_delete_app.confirm_field_text') : this.$t('partials.dialog_confirm_delete_app.rules_not_valid')
                ];
            }
        },
    },
    mounted() {},
    methods: {
        open (title=null, text=null){
            this.titleAsData = title;
            this.textAsData = text;
            this.displayDialog = true;
            return new Promise((resolve) => {
                this.resolve = resolve;
            });
        },
        async confirm (){
            if(this.$refs.form.validate()){
                await this.callbackConfirm();
                this.resolve(true);
                this.displayDialog = false;
            }
        },
        async cancel (){
            await this.callbackDecline();
            this.resolve(false);
            this.displayDialog = false;
        },
    },
};

</script>
<style lang="scss">
.dialog-text{
    color: $main-light-color;
    padding-left: 1em;
    padding-right: 1em;
    margin-top: 1em;
}
.dialog-confirm-delete-buttons{
    justify-content: space-between;
}
.dialog-confirm-title{
    color: $main-light-color;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/dialog-confirm-delete.vue